import { WebPage } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Head from 'next/head';

export const StaticPageSchemaOrg = ({
  description,
  name,
}: {
  description: string;
  name: string;
}) => {
  return (
    <Head>
      <script
        defer
        {...jsonLdScriptProps<WebPage>({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name, //meta title
          description, //meta description
          publisher: {
            '@type': 'Organization',
            name: 'Setur Servis Turistik A.Ş.',
          },
        })}
      />
    </Head>
  );
};
